import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselIndicatorsFn = /* @__PURE__ */ createRecipe('carousel-indicators', {}, [])

const carouselIndicatorsVariantMap = {}

const carouselIndicatorsVariantKeys = Object.keys(carouselIndicatorsVariantMap)

export const carouselIndicators = /* @__PURE__ */ Object.assign(memo(carouselIndicatorsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselIndicators',
  __getCompoundVariantCss__: carouselIndicatorsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselIndicatorsVariantKeys,
  variantMap: carouselIndicatorsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselIndicatorsVariantKeys)
  },
  getVariantProps: carouselIndicatorsFn.getVariantProps,
})